import { useEffect, useRef, useState } from 'react';
import { IoChevronDown } from 'react-icons/io5';
import { useLanguage } from '../../../context/LanguageContext';
import './LanguageSwitcher.css';

export default function LanguageSwitcher({ className = '' }) {
  const { language, setLanguage, languages } = useLanguage();
  const [open, setOpen] = useState(false);
  const rootRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = (e) => {
      if (rootRef.current && !rootRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  const current = languages.find((l) => l.code === language);

  return (
    <div
      ref={rootRef}
      className={`language-switcher-wrap ${className}`.trim()}
    >
      <button
        type="button"
        className="language-switcher"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-haspopup="listbox"
        aria-label="Select language"
      >
        {current?.code.toUpperCase() ?? 'EN'}
        <IoChevronDown
          className={`language-switcher-arrow${open ? ' language-switcher-arrow--open' : ''}`}
          aria-hidden
        />
      </button>
      {open ? (
        <ul className="language-switcher-menu" role="listbox">
          {languages.map((lang) => (
            <li key={lang.code} role="option" aria-selected={lang.code === language}>
              <button
                type="button"
                className={`language-switcher-option${
                  lang.code === language ? ' language-switcher-option--active' : ''
                }`}
                onClick={() => {
                  setLanguage(lang.code);
                  setOpen(false);
                }}
              >
                {lang.label}
              </button>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
